import { Action, createAction, props } from '@ngrx/store';
import { IField } from '@app/models/field.model';
import { FieldEntityType } from '@app/models/FieldEntityType';

export enum FieldsActions {
    GetAllFields = '[Fields] Get All Fields',
    GetFieldsByProjectType = '[Fields] Get Fields By Project Type',
    GetLibraryFieldsByProjectType = '[Fields] Get Library Fields By Project Type',
    GetFieldsByProject = '[Fields] Get Fields By Project',
    FieldsLoaded = '[Fields] Load success',
    AllFieldsLoaded = '[Fields] All Fields Load success',
    LibraryFieldsLoaded = '[Fields] Library Fields Load success',
    AddFields = '[Fields] Add Field',
    BeginRemoveField = '[Fields] Begin Remove Field',
    RemoveField = '[Fields] Remove Field',
    BeginUpdateField = '[Fields] Begin Update Field',
    UpdateField = '[Fields] Update Field',
    SelectField = '[Fields] Select Field',
    SetSearchText = '[Fields] Set Search Text',
    BeginFetchSelectedField = '[Fields] Begin fetch selected field',
    SuccessFetchSelectedField = '[Fields] Success fetch selected field',
    BeginCreateField = '[Fields] Begin create field',
    SuccessCreateField = '[Fields] Success create field',
    ErrorFields = '[Fields] Error'
}

export const AddFieldsAction = createAction(
    FieldsActions.AddFields,
    props<{ payload: {fields: IField[], projectTypeId, entityType: FieldEntityType } }>()
);
export const BeginRemoveFieldAction = createAction(
  FieldsActions.BeginRemoveField,
  props<{ payload: IField }>()
);
export const RemoveFieldAction = createAction(
    FieldsActions.RemoveField,
    props<{ payload: IField }>()
);


export const BeginUpdateFieldAction = createAction(
    FieldsActions.BeginUpdateField,
    props<{ payload: IField }>()
);

export const UpdateFieldAction = createAction(
    FieldsActions.UpdateField,
    props<{ payload: IField }>()
);

export const GetAllFieldsAction = createAction(
    FieldsActions.GetAllFields
);
export const AllFieldsLoadedAction = createAction(
    FieldsActions.AllFieldsLoaded,
    props<{
        payload: {
            fields: IField[],
        }
    }>()
);

export const GetFieldsAction = createAction(
    FieldsActions.GetFieldsByProjectType,
    props<{ payload: { typeId: string, entityType?: FieldEntityType } }>()
);

export const GetFieldsByProjectAction = createAction(
    FieldsActions.GetFieldsByProject,
    props<{
        payload: {
            projectId: string
        }
    }>()
);

export const FieldsLoadedAction = createAction(
    FieldsActions.FieldsLoaded,
    props<{
        payload: {
            fields: IField[]
        }
    }>()
);

export const GetLibraryFieldsAction = createAction(
    FieldsActions.GetLibraryFieldsByProjectType,
    props<{ payload: { typeId: string } }>()
);


export const LibraryFieldsLoadedAction = createAction(
    FieldsActions.LibraryFieldsLoaded,
    props<{
        payload: {
            fields: IField[]
        }
    }>()
);

export const SelectFieldAction = createAction(
    FieldsActions.SelectField,
    props<{ payload: IField }>()
);

export const BeginFetchSelectedFieldAction = createAction(
    FieldsActions.BeginFetchSelectedField,
    props<{ payload: { fieldId: string } }>()
);

export const SuccessFetchSelectedFieldAction = createAction(
    FieldsActions.SuccessFetchSelectedField,
    props<{ payload: IField }>()
);

export const BeginCreateFieldAction = createAction(
    FieldsActions.BeginCreateField,
    props<{ payload: { projectTypeId: string,
        field: IField, entityType: FieldEntityType } }>()
);

export const SuccessCreateFieldAction = createAction(
    FieldsActions.SuccessCreateField,
    props<{ payload: IField }>()
);

export const ErrorFieldsAction = createAction(
    FieldsActions.ErrorFields, props<Error>()
);


export const SetSearchTextAction = createAction(
    FieldsActions.SetSearchText,
    props<{ payload: string }>()
);
